export default __webpack_public_path__ + "static/media/doctor2.373043e6.jpg";